/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { isEmpty, keys, pickBy } from 'lodash';
import useWindowSize from '../../../hooks/useWindowSize';
import queryString from 'query-string';
import moment from 'moment';
import BobLoadingMask from '../../../components/BobLoadingMask';
import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import HealthMonitorTableContextMenu from './HealthMonitorTableContextMenu';
import HealthInfoModal from '../Modals/HealthInfoModal';
import CreateServiceRequestModal from '../Modals/CreateServiceRequestModal';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';
import {getTimeZoneAbbr} from '../../../helpers/timezones';
import * as HomeActions from '../../../actions/homeActions';
import * as BobActions from '../../../actions/bobActions';
import * as ServiceManagementActions from '../../../actions/serviceManagementActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import * as classes from './HealthMonitorTable.module.css';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const HealthMonitorTable = ({
    node,
    activeNavClient,
    activeNavCompany,
    activeNavEquipment,
    activeNavSite,
    bobLoading,
    clearHealthChecks,
    exportColumns,
    exportRef,
    isexportNodeHealthChecks,
    exportNodeHealthChecks,
    fetchSingleClient,
    fetchIssueTypes,
    fetchSingleEquipment,
    fetchSingleSite,
    fetchNodeHealthChecks,
    getCardFaultScores,
    healthChecks,
    healthChecksMeta,
    healthMonitorFilters,
    history,
    refreshTab,
    searchTerm,
    setExportColumns,
    setIsexportNodeHealthChecks,
    setRefreshTab,
    setSubscribeToRuleAlertsModalOpen,
    subscribeToRuleAlertsModalOpen,
    ...props
}) => {
    const [sort, setSort] = useState([]);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(100);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageable] = useState({ pageSizes: [50, 100, 200] });
    const [healthInfoModalOpen, setHealthInfoModalOpen] = useState(false);
    const [createServiceRequestModalOpen, setCreateServiceRequestModalOpen] = useState(false);
    const [selectedHealthCheck, setSelectedHealthCheck] = useState({});
    const [activeHealthChecks, setActiveHealthChecks] = useState([]);
    const [ruleNameColumnWidth, setRuleNameColumnWidth] = useState(250);
    const [ruleData, setRuleData] = useState({});
    const [parentLabel, setParentLabel] = useState('Equipment');

    const queryValues = queryString.parse(history.location.search);

    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    const getExportColumns = () => {
        const columns = gridRef.current.props.children.filter(c => c.key !== null);
        const exportColumnList = columns.sort((a, b) => a.key - b.key).map(c => {
            return c.props;
        });
        return exportColumnList;
    };

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setRuleNameColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'name', 250, true));
    }, [windowSize]);

    useEffect(() => {
        setActiveHealthChecks(healthChecks);
        setTotalRecords(healthChecksMeta.totalCount);
    }, [healthChecks, healthChecksMeta]);

    useEffect(() => {
        if (searchTerm) {
            const filteredHealthChecks = healthChecks.filter(obj => obj.name.toLowerCase().includes(searchTerm.toLowerCase()));

            setActiveHealthChecks(filteredHealthChecks);
        } else {
            setActiveHealthChecks(healthChecks);
        }
    }, [searchTerm]);

    useEffect(() => {

        return () => {
            clearHealthChecks();
        };
    }, []);

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setRuleNameColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'name', 250, true));
        setExportColumns(getExportColumns());
    }, []);

    const getFilters = () => {
        if (healthMonitorFilters) {
            let typeFilters = [];
            let priorityFilters = [];
            let statusFilters = [];

            if (!isEmpty(healthMonitorFilters.type)) {
                typeFilters = healthMonitorFilters.type.map(filter => filter.id);
            }

            if (Object.values(healthMonitorFilters.priority).includes(true)) {
                priorityFilters = keys(pickBy(healthMonitorFilters.priority));
            }

            if (!isEmpty(healthMonitorFilters.status)) {
                statusFilters = healthMonitorFilters.status;
            }

            return  {
                type:     typeFilters,
                priority: priorityFilters,
                status:   statusFilters
            };
        }
    };

    // Export entity health checks
    useEffect(() => {
        const init = async () => {
            const filters = getFilters();
            await exportNodeHealthChecks(selectedNode, {}, filters.type, filters.priority, filters.status);
            setIsexportNodeHealthChecks(false);
        };

        const selectedNode = {
            type: node.type,
            id:   node.id
        };
        
        if (node.id && isexportNodeHealthChecks) init();
    }, [isexportNodeHealthChecks]);

    useEffect(() => {
        const init = async () => {
            const filters = getFilters();
            
            await Promise.all([
                getCardFaultScores(node.id),
                fetchIssueTypes(),
                fetchNodeHealthChecks(selectedNode, { page: 1, pagesize: take }, filters.type, filters.priority, filters.status)
            ].map(p => p.catch(err => err)));
        };

        const selectedNode = {
            type: node.type,
            id:   node.id
        };

        if (activeNavCompany.id && node.type === 'company') init();
    }, [activeNavCompany, healthMonitorFilters]);

    useEffect(() => {
        const init = async () => {
            const filters = getFilters();

            await Promise.all([
                getCardFaultScores(node.id),
                fetchIssueTypes(),
                fetchNodeHealthChecks(selectedNode, { page: 1, pagesize: take }, filters.type, filters.priority, filters.status)
            ].map(p => p.catch(err => err)));
        };

        const selectedNode = {
            type: node.type,
            id:   node.id
        };

        if (activeNavClient.id && node.type === 'client') init();
    }, [activeNavClient, healthMonitorFilters]);

    useEffect(() => {
        const init = async () => {
            const filters = getFilters();

            await Promise.all([
                getCardFaultScores(node.id),
                fetchIssueTypes(),
                fetchNodeHealthChecks(selectedNode, { page: 1, pagesize: take }, filters.type, filters.priority, filters.status)
            ].map(p => p.catch(err => err)));
        };

        const selectedNode = {
            type: node.type,
            id:   node.id
        };

        if (activeNavSite.id && node.type === 'site') init();
    }, [activeNavSite, healthMonitorFilters]);

    useEffect(() => {
        const init = async () => {
            const filters = getFilters();

            await Promise.all([
                getCardFaultScores(node.id),
                fetchIssueTypes(),
                fetchNodeHealthChecks(selectedNode, { page: 1, pagesize: take }, filters.type, filters.priority, filters.status)
            ].map(p => p.catch(err => err)));
        };

        const selectedNode = {
            type: node.type,
            id:   node.id
        };

        if (activeNavEquipment.id && node.type === 'equipmentItem') init();
    }, [activeNavEquipment, healthMonitorFilters]);

    useEffect(() => {
        const init = async () => {
            const filters = getFilters();

            await Promise.all([
                getCardFaultScores(node.id),
                fetchIssueTypes(),
                fetchNodeHealthChecks(selectedNode, { page: 1, pagesize: take }, filters.type, filters.priority, filters.status)
            ].map(p => p.catch(err => err)));
        };

        const selectedNode = {
            type: node.type,
            id:   node.id
        };

        if (activeNavSite.id && queryValues.system && node.type === 'systemItem') init();
    }, [activeNavSite, healthMonitorFilters]);

    useEffect(() => {
        const refresh = async () => {
            let page = 1;
            
            if ( skip && take ) {
                page = skip / take + 1;
            }

            const selectedNode = {
                type: node.type,
                id:   node.id
            };
    
            await fetchNodeHealthChecks(selectedNode, { page, pagesize: take });

            if (searchTerm) {
                const filteredHealthChecks = healthChecks.filter(obj => obj.name.toLowerCase().includes(searchTerm.toLowerCase()));
    
                setActiveHealthChecks(filteredHealthChecks);
            } else {
                setActiveHealthChecks(healthChecks);
            }
            
            setRefreshTab('');
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const onSubscribeToAlerts = dataItem => {
        if (dataItem.equipmentId !== EMPTY_GUID) {
            setParentLabel('Equipment');
            ruleData.name = dataItem.equipmentName;
            ruleData.id = dataItem.equipmentId;
        }
        else {
            setParentLabel('System');
            ruleData.name = dataItem.systemName;
            ruleData.id = dataItem.systemId;
        }
        ruleData.ruleName = dataItem.name;
        ruleData.ruleId = dataItem.ruleId;
        ruleData.clientId = dataItem.clientId;

        setRuleData(ruleData);
        setSubscribeToRuleAlertsModalOpen(true);
    };

    const handlePageChange = async event => {
        setSkip(event.page.skip);
        setTake(event.page.take);

        let page = 1;

        if (event.page.skip > 0) {
            page = event.page.skip / event.page.take + 1;
        }

        const selectedNode = {
            type: node.type,
            id:   node.id
        };

        const filters = getFilters();

        await fetchNodeHealthChecks(selectedNode, { page, pagesize: event.page.take }, filters.type, filters.priority, filters.status);
    };

    const renderPriorityCell = props => {
        const value = props.dataItem.priority;

        let imgPath = '/assets/images/low.svg';
        if (value === 1) {
            imgPath = '/assets/images/medium.svg';
        } else if (value === 2) {
            imgPath = '/assets/images/high.svg';
        }

        switch (value) {
            case 0:
                return (
                    <td>
                        <img className={classes.IconImage} src={imgPath} alt="" />
                        Low
                    </td>
                );
            case 1:
                return (
                    <td>
                        <img className={classes.IconImage} src={imgPath} alt="" />
                        Medium
                    </td>
                );
            case 2:
                return (
                    <td>
                        <img className={classes.IconImage} src={imgPath} alt="" />
                        High
                    </td>
                );
            default:
                return <td>-</td>;
        }
    };

    const renderStatusCell = props => {
        const value = props.dataItem.status;

        switch (value) {
            case true:
                return <td>Fault</td>;
            case false:
                return <td>Ok</td>;
            default:
                return <td>-</td>;
        }
    };

    const renderFaultTimestamp = props => {
        const value = props.dataItem.faulttimestamp;
        if (value) {
            const zone = moment.tz.guess();
            const displayTime = moment(value).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(value), zone);
            return <td>{displayTime}</td>;
        }
        else {
            return <td>{value}</td>;
        }
    };

    const redirectToEntityUrl = (dataItem, type) => {
        const queryValues = queryString.parse(history.location.search);
        
        if (type === 'clientName') {
            return `client?client=${dataItem.clientId}&company=${queryValues.company}`;
        } else if (type === 'siteName') {
            return `site?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}`;
        } else if (type === 'equipment') {
            return `equipment?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}&equipment=${dataItem.equipmentId}`;
        } else if (type === 'system') {
            return `system?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}&system=${dataItem.systemId}`;
        }
    };
    
    const redirectToEntityClick = async (dataItem, type) => {
        const queryValues = queryString.parse(history.location.search);
        let path = '/v2/dashboard/';
        let entity = '';

        if (type === 'clientName') {
            entity = 'client';
            queryValues.client = dataItem.clientId;
            queryValues.childId = 'f6ba2344-ba47-42c5-a98b-978365ca3936';
            await fetchSingleClient(queryValues);
        } else if (type === 'siteName') {
            entity = 'site';
            queryValues.client = dataItem.clientId;
            queryValues.site = dataItem.siteId;
            queryValues.childId = 'bb5be75b-d466-48d5-99da-79cd66504f20';
            await fetchSingleSite(queryValues);
        } else if (type === 'equipment') {
            entity = 'equipment';
            queryValues.client = dataItem.clientId;
            queryValues.site = dataItem.siteId;
            queryValues.equipment = dataItem.equipmentId;
            queryValues.childId = 'c49ee7a9-6a28-4820-967c-6c6a9652a4c8';
        } else if (type === 'system') {
            entity = 'system';
            queryValues.client = dataItem.clientId;
            queryValues.site = dataItem.siteId;
            queryValues.system = dataItem.systemId;
            queryValues.childId = '00a75c91-5483-4c84-bb09-eb037f47bdc9';
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}${entity}?${queryValuesString}`);

        if (type === 'clientName') {
            await fetchSingleClient(queryValues);
        } else if (type === 'siteName') {
            await fetchSingleSite(queryValues);
        } else if (type === 'equipment') {
            const equipmentOptions = {extendedData: true};
            await fetchSingleEquipment(queryValues, equipmentOptions);
        }
    };

    const renderEntityCell = props => {
        return (
            <td>
                <Link
                    to={redirectToEntityUrl(props.dataItem, props.field)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                redirectToEntityClick(props.dataItem, props.field);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const renderEquipmentSystemCell = props => {
        let isEquipment = props.dataItem.equipmentName ? true : false; 

        return (
            <td>
                {
                    node.type === 'equipmentItem' || node.type === 'systemItem' ?
                        isEquipment ? props.dataItem.equipmentName : props.dataItem.systemName
                        :
                        <Link
                            to={redirectToEntityUrl(props.dataItem, isEquipment ? 'equipment' : 'system')}
                            onClick={
                                (e) => {
                                    if (!e.ctrlKey) {
                                        redirectToEntityClick(props.dataItem, isEquipment ? 'equipment' : 'system');
                                    }
                                }
                            }
                        >
                            {isEquipment ? props.dataItem.equipmentName : props.dataItem.systemName}
                        </Link>
                }
            </td>
        );

    };

    const renderIssueTypeCell = props => {
        const issueTypes = props.dataItem.issueTypes;

        return (
            <td>
                {issueTypes.join(', ')}
            </td>
        );
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <HealthMonitorTableContextMenu
                    dataItem={props.dataItem}
                    setCreateServiceRequestModalOpen={setCreateServiceRequestModalOpen}
                    setHealthInfoModalOpen={setHealthInfoModalOpen}
                    setSelectedHealthCheck={setSelectedHealthCheck}
                    onSubscribeToAlerts={onSubscribeToAlerts}
                />
            </td>
        );
    };

    const onColumnReorder = e => {
        setExportColumns(e.columns.sort((a, b) => a.orderIndex - b.orderIndex));
    };

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
            </style>
            <div ref={gridDivRef} className={ classes.Table }>
                <ExcelExport
                    data={ orderBy(activeHealthChecks, sort)}
                    ref={ exportRef }
                >
                    {
                        exportColumns.length > 0 ? exportColumns.map((column, index) => (
                            <ExcelExportColumn
                                key={ index }
                                field={ column.field }
                                title={ column.title }
                            />
                        ))
                            : null
                    }
                </ExcelExport>
                <Grid
                    ref={gridRef}
                    sortable
                    sort={sort}
                    onSortChange={(e) => {
                        setSort(e.sort);
                    }}
                    className={classes.KendoGrid}
                    data={orderBy(activeHealthChecks, sort)}
                    take={take}
                    skip={skip}
                    onPageChange={handlePageChange}
                    pageable={pageable}
                    reorderable
                    onColumnReorder={onColumnReorder}
                    total={totalRecords}
                >
                    {
                        bobLoading.includes('FetchHealthChecks') || isEmpty(healthChecksMeta) ?
                            <GridNoRecords>
                                Loading Health Records
                            </GridNoRecords>
                            : healthChecks.message ?
                                <GridNoRecords>
                                    {healthChecksMeta.message}
                                </GridNoRecords>
                                : null
                    }
                    <Column
                        key={1}
                        field="name"
                        title={'Rule Name'}
                        id="ruleNameColumn"
                        width={ruleNameColumnWidth}
                    />
                    <Column
                        key={2}
                        field="clientName"
                        title={'Client'}
                        width={200}
                        cell={renderEntityCell}
                    />
                    <Column
                        key={3}
                        field="siteName"
                        title={'Site'}
                        width={200}
                        cell={renderEntityCell}
                    />
                    <Column
                        key={4}
                        title={'Equipment/System'}
                        field="equipmentSystem"
                        width={180}
                        cell={renderEquipmentSystemCell}
                    />
                    <Column
                        key={5}
                        field="snapshotRoute"
                        title={'Target'}
                        width={300}
                    />
                    <Column
                        key={6}
                        title={'Status'}
                        field="status"
                        width={80}
                        cell={renderStatusCell}
                    />
                    <Column
                        key={7}
                        title={'Fault Started'}
                        field="faulttimestamp"
                        width={180}
                        cell={renderFaultTimestamp}
                    />
                    <Column
                        key={8}
                        title={'Priority'}
                        field="priority"
                        width={120}
                        cell={renderPriorityCell}
                    />
                    <Column
                        key={9}
                        title={'Issue Type'}
                        field="issueTypes"
                        width={225}
                        cell={renderIssueTypeCell}
                    />
                    <Column
                        key={10}
                        field=""
                        title=""
                        width="75px"
                        cell={actionsCell}
                        locked={true}
                        sortable={false}
                        filterable={false}
                        reorderable={false}
                    />
                </Grid>
                {
                    subscribeToRuleAlertsModalOpen ?
                        <CreateSubscriptionModal
                            parent={ruleData}
                            parentLabel={parentLabel}
                            type="rule"
                            handleToggleSubscribeToAlertsModal={setSubscribeToRuleAlertsModalOpen}
                        />
                        :
                        null
                }
                {
                    createServiceRequestModalOpen ?
                        <CreateServiceRequestModal
                            setCreateServiceRequestModalOpen={setCreateServiceRequestModalOpen}
                            selectedHealthCheck={selectedHealthCheck}
                        />
                        :
                        null
                }
                {
                    healthInfoModalOpen ?
                        <HealthInfoModal
                            setHealthInfoModalOpen={setHealthInfoModalOpen}
                            selectedHealthCheck={selectedHealthCheck}
                        />
                        :
                        null
                }
                {
                    isEmpty(healthChecksMeta) || bobLoading.includes('FetchHealthChecks') ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    activeNavClient:    state.bob.activeNavClient,
    activeNavCompany:   state.bob.activeNavCompany,
    activeNavEquipment: state.bob.activeNavEquipment,
    activeNavSite:      state.bob.activeNavSite,
    bobLoading:         state.bob.bobLoading,
    healthChecks:       state.home.healthChecks,
    healthChecksMeta:   state.home.healthChecksMeta
});

const mapDispatchToProps = ({
    ...BobActions,
    ...HomeActions,
    ...ServiceManagementActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HealthMonitorTable));
